export function isEdge(): boolean {
	if (window.navigator.userAgent.includes('Edg/')) {
		return true;
	}
	return false;
}
